import { ToastProgrammatic as Toast } from 'buefy'

export default new class NotificationService {
  warning (message) {
    Toast.open({
      duration: 5000,
      message: message,
      position: 'is-bottom',
      type: 'is-danger'
    })
  }
  message (message) {
    Toast.open({
      duration: 5000,
      message: message,
      position: 'is-bottom'
    })
  }
}()
